/**
 * Auslesen des access_token (JWT) aus der response url vom OAM
 *
 * @param url
 */
export function getAccessToken(url) {
  const urlParam = 'access_token';
  return getUrlParam(urlParam, url);
}
function getUrlParam(urlParam, url) {
  const regex = new RegExp('[\?&#]' + urlParam + '=([^&#]*)');
  const results = regex.exec(url);
  return results === null ? '' : results[1];
}
//# sourceMappingURL=oam.util.js.map
